import styled from "styled-components"

export const SearchFormContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: flex-start;
  width: 880px;
  margin: 0 auto;
  max-width: 100%;
  padding: 2rem;
  background: var(--white);
  .innerContainer {
    width: 100%;
  }
  input {
    border: none !important;
    outline: none !important;
    -webkit-appearance: none;
    outline-offset: 0;
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: var(--illiniDarkBlue);
    margin: 0.25rem;
    flex: 1;
  }
  input:focus {
    border: none !important;
    outline: none !important;
    -webkit-appearance: none;
    outline-offset: 0;
  }

  input:active {
    border: none !important;
    outline: none !important;
    -webkit-appearance: none;
    outline-offset: 0;
  }

  .searchBorder {
    border: 2px solid var(--illiniDarkBlue);
    border-radius: 8px;
    margin-top: 1rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 991px) {
    input {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    input {
      width: 100%;
    }
  }
`
export const FilterContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  background: var(--white);

  p {
    width: 50%;
  }

  .btn {
    width: 200px;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-right: 0.5rem;
  }

  .selected {
    background: var(--illiniDarkBlue);
    color: white;
  }

  .selected:hover {
    color: var(--illiniDarkBlue);
    border: 2px solid var(--illiniDarkBlue);
    background: var(-white);
  }

  @media (max-width: 991px) {
    .btn {
      display: block;
      margin: 0 auto;
      margin-top: 1rem;
    }
    p {
      margin-top: 1.5rem;
    }

    .secondaryLabelMax > .btn {
      margin-top: 0;
    }
  }

  @media (max-width: 480px) {
    .btn {
      display: block;
      margin: 0 auto;
      margin-top: 1rem;
    }
    p {
      margin-top: 1.5rem;
    }

    .secondaryLabelMax > .btn {
      margin-top: 0;
    }
  }
`
